import { type FC, useCallback } from "react";
import { ActionDisabledTooltip, type ActionDisabledTooltipProps } from "../../common/components/ActionDisabledTooltip";
import { VendorDataCollection } from "../models";
import { type VendorDataChangedAction } from "../vendorDataReducer";
import { VendorDataContainer, SectionTitle, AddNew, AddNewIcon } from "./VendorDataSection.styles";
import { VendorDataInputs } from "./VendorDataInputs";

interface VendorDataSectionProps {
    className?: string;
    centerAddButton?: boolean;
    vendorDataCollection: VendorDataCollection;
    onVendorDataChanged: (event: VendorDataChangedAction) => void;
    disabled?: boolean;
}

export const VendorDataSection: FC<VendorDataSectionProps & ActionDisabledTooltipProps> = ({
    className,
    vendorDataCollection,
    onVendorDataChanged,
    disabled = false,
    centerAddButton = false,
    hasPermission,
    placement,
}) => {
    const addVendorData = useCallback(() => {
        if (!disabled) {
            onVendorDataChanged({ type: "add" });
        }
    }, [disabled, onVendorDataChanged]);

    const { vendorData, isMaxCount } = vendorDataCollection;

    const duplicatedKeys = vendorDataCollection.getNonUniqueKeys();

    return (
        <VendorDataContainer className={className}>
            <SectionTitle>Vendor Data</SectionTitle>
            {vendorData.map((entry) => (
                <VendorDataInputs
                    key={entry.index}
                    entry={entry}
                    disabled={disabled}
                    onVendorDataChanged={onVendorDataChanged}
                    isDuplicate={duplicatedKeys.has(entry.data.key as string)}
                />
            ))}
            <AddNew
                justifyContent={centerAddButton ? "center" : "flex-start"}
                alignItems={centerAddButton ? "center" : "flex-start"}
                onClick={addVendorData}
                hidden={isMaxCount}
                role="add-vendor-data"
                disabled={disabled}
            >
                <ActionDisabledTooltip placement={placement} hasPermission={hasPermission}>
                    <AddNewIcon name="add" /> Add Vendor Data
                </ActionDisabledTooltip>
            </AddNew>
        </VendorDataContainer>
    );
};
